import { useEffect, useState } from 'react';
import { getDocuments } from '../api/documents';
import styles from './Documents.module.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
};

const getFileIcon = (fileType) => {
  if (fileType === 'application/pdf') return { label: 'PDF', cls: styles.iconPdf };
  return { label: 'DOC', cls: styles.iconDoc };
};

const Documents = () => {
  const [docs, setDocs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Документы — Терушкин ОС';
    getDocuments()
      .then((data) => setDocs(data.documents))
      .catch(() => setError('Не удалось загрузить документы'))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <h1 className={styles.title}>Документы</h1>
        <p className={styles.subtitle}>
          Юридические документы клуба: договоры, политика конфиденциальности, публичная оферта и другие материалы.
        </p>

        {isLoading && <div className={styles.loading}>Загрузка...</div>}
        {error && <div className={styles.error}>{error}</div>}

        {!isLoading && !error && docs.length === 0 && (
          <div className={styles.empty}>Документов пока нет</div>
        )}

        {!isLoading && !error && docs.length > 0 && (
          <div className={styles.list}>
            {docs.map((doc) => {
              const icon = getFileIcon(doc.file_type);
              return (
                <a
                  key={doc.id}
                  href={`${API_URL}${doc.file_url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.card}
                >
                  <div className={`${styles.icon} ${icon.cls}`}>{icon.label}</div>
                  <div className={styles.info}>
                    <p className={styles.docTitle}>{doc.title}</p>
                    {doc.description && <p className={styles.docDesc}>{doc.description}</p>}
                  </div>
                  <div className={styles.meta}>
                    <span className={styles.fileSize}>{formatFileSize(doc.file_size)}</span>
                    <br />
                    <span className={styles.downloadHint}>Скачать</span>
                  </div>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Documents;
